import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "./element-variables.scss";
import "./assets/styles/common.scss";
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
// import * as VueGoogleMaps from 'vue2-google-maps'
// import './plugins/vue-lazyload.js'
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
import VueLazyLoad from 'vue-lazyload'
import filters from '@/plugins/filters' 
import store from './store'

import 'animate.css'

// 引入语言文件（需要对哪些内容进行翻译就在文件中写入哪些内容）
import de from '@/common/lang/de'
import en from '@/common/lang/en'
import pl from '@/common/lang/pl'
import zh from '@/common/lang/zh'
import  VueI18n from 'vue-i18n'
import { EN_LANG, LANG } from "./common/baseConst";
import enLocale from 'element-ui/lib/locale/lang/en' 
import deLocale from 'element-ui/lib/locale/lang/de' 
import plLocale from 'element-ui/lib/locale/lang/pl'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { recordVisitor } from "@/api/oss/visitor";
import { MERCHANT_ID } from "@/api/oss/products";


// Vue.use(VueI18n)

// const i18n = new VueI18n({
//   locale: localStorage.getItem('lang') || 'zh',
//   // 配置语言文件对象
//   messages: {en,dn}
// })
Vue.use(VueI18n)

let lang = localStorage.getItem(LANG)
//设置默认
if(lang == null || lang == '') {
    lang = EN_LANG;
    localStorage.setItem(LANG,EN_LANG);
}
const i18n = new VueI18n({
  legacy: false, 
  locale: lang, // 初始化显示中文
  messages: {
    'en':{...enLocale,...en},
    'de':{...deLocale,...de},
    'pl':{...plLocale,...pl}, // 这里的plLocale是ElementUI的语言包
    'zh':{...zhLocale,...zh}
}, // 这里就是你有几种语言，对象里面就有几个
  globalInjection: true, //全局生效$t
})
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
 
// window.$t = i18n.global.t
//i18n.t('not.found', 1, {locale: 'en', fallbackLocale: 'fr', missingFallbackLocale: true})

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: '', // google keyAIzaSyDJH74cHlLYoFv5DQWB0oZOvlTYEZf6GsA
//     libraries: 'places'
//   }
// })
// https://www.oss-energie.de/mobile/#/index

//定义加载中的图片(如果用到的话可以用)
// const loadimage = require('~/static/icons/common/loading.gif')
//定义加载图片出错的时候展现的图片
// const errorimage = require('~/static/icons/common/picture-error.png')

Vue.use(VueLazyLoad, {
  preLoad: 1.33, //预加载高度比例
  // error: errorimage, //加载失败时图像的src
  attempt: 2,//尝试计数次数
  throttleWait: 500,//节流等待时间(通过调节此值可以查看loading的效果，根据实际情况调节)
  filter: {
    progressive(listener, options) {
      // 实现渐近式加载图片（先加载模糊的图）
      listener.el.setAttribute('lazy-progressive', 'true')
      // 先加载模糊的图（这个地方是替换图片中的宽度与高度大小）
      let loadingUrl = listener.src.replace(/w_[0-9]+/g, 'w_5')
      loadingUrl = loadingUrl.replace(/h_[0-9]+/g, 'h_5')
      listener.loading = loadingUrl
    }
  }
})

import "swiper/dist/css/swiper.css";
Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
  const authPath = ['/cart', '/pay', '/pay2', '/ord', '/address'];
  if (to.path === '/login') {
    next();
    return;
  }
  if (authPath.includes(to.path)) {
    if (process.env.NODE_ENV !== 'production' && to.query.designPreview === '1') {
      next();
      return;
    }
    const token = localStorage.getItem('front_token');
    if (token === null || token === '' || token === 'undefined') {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  // 异步上报访客记录，不阻塞主流程
  try {
    const recordData = {
      merId: MERCHANT_ID,
      path: to.fullPath,
      pageTitle: document.title || to.name || to.path,
      referer: document.referrer || '',
      sessionId: sessionStorage.getItem('visitor_session_id') || ''
    };
    
    // 初始化会话ID
    if (!recordData.sessionId) {
      recordData.sessionId = 'sess_' + Math.random().toString(36).substr(2, 9) + Date.now();
      sessionStorage.setItem('visitor_session_id', recordData.sessionId);
    }
    
    recordVisitor(recordData);
  } catch (e) {
    console.error('Visitor record failed:', e);
  }
});

/* 全局注册过滤器 */
Object.keys(filters).forEach(item => Vue.filter(item,filters[item]))

const currentLang = i18n.locale || 'de';
document.documentElement.lang = currentLang === 'en' ? 'en-GB' : 
                                currentLang === 'de' ? 'de-DE' : 
                                currentLang === 'pl' ? 'pl-PL' : currentLang;

new Vue({
  render: (h) => h(App),
  i18n,
  router,
  store
}).$mount("#app");
